package br.com.duoma.duomaproducao.repository

import br.com.duoma.duomaproducao.model.ProductionOrderItemReport
import io.ktor.client.HttpClient
import io.ktor.client.request.port
import io.ktor.client.request.post
import io.ktor.client.statement.bodyAsText
import io.ktor.http.HttpHeaders
import io.ktor.http.isSuccess
import kotlinx.serialization.json.Json
import kotlinx.serialization.json.JsonArray
import kotlinx.serialization.json.JsonObject
import kotlinx.serialization.json.decodeFromJsonElement
import kotlinx.serialization.json.jsonObject

private const val PRODUCTION_REPORT_ENDPOINT = "https://api.duomagenda.qzz.io/production/update"

private val httpClient = HttpClient()

private val json = Json {
    ignoreUnknownKeys = true
}

actual suspend fun getProductionReport(password : String): List<ProductionOrderItemReport> {
    val response = httpClient.post(PRODUCTION_REPORT_ENDPOINT) {
        headers[HttpHeaders.Authorization] = password
    }
    val body = response.bodyAsText()

    if (!response.status.isSuccess()) {
        val details = body.takeIf { it.isNotBlank() }?.let { ": $it" }.orEmpty()
        error("Erro ao buscar produção. HTTP ${response.status.value}$details")
    }

    val responseJson = json.parseToJsonElement(body).jsonObject
    return json.decodeFromJsonElement(responseJson.productionItems())
}

private fun JsonObject.productionItems(): JsonArray =
    listOf("items", "data", "production", "reports", "result")
        .firstNotNullOfOrNull { this[it] as? JsonArray }
        ?: values.filterIsInstance<JsonArray>().firstOrNull()
        ?: error("Resposta de produção não contém uma lista de itens.")
